import type { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import React from 'react'
import { DataType } from './interface'
import { Sorter } from '../../../../interfaces'
import { EditOutlined, DeleteOutlined, StopOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import { ButtonActionWrapper } from '../../../../components/list-operations/styles'

const createColumns = (
  onStop: (record: DataType) => void,
  onEdit: (record: DataType) => void,
  onDelete: (record: DataType) => void,
): ColumnsType<DataType> => [
  {
    title: 'Дата начала',
    dataIndex: 'date_start',
    key: 'date_start',
    width: 120,
    sorter: true,
    render: key => (key ? dayjs(key).format('DD.MM.YYYY') : ''),
  },
  {
    title: 'Дата окончания',
    dataIndex: 'date_end',
    key: 'date_end',
    width: 120,
    sorter: true,
    render: key => (key ? dayjs(key).format('DD.MM.YYYY') : ''),
  },
  {
    title: 'Вакансия',
    dataIndex: 'vacancy',
    key: 'vacancy',
    width: 200,
    sorter: true,
    render: (_, record) => record.vacancy || `ID: ${record.vacancy_id}`,
  },
  {
    title: 'Отдел',
    dataIndex: 'department',
    key: 'department',
    width: 200,
    sorter: true,
    render: (_, record) => record.department || `ID: ${record.department_id}`,
  },
  {
    title: 'Количество',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 100,
    sorter: true,
  },
  {
    title: 'Действия',
    key: 'actions',
    width: 120,
    fixed: 'right',
    render: (_, record) => {
      const handleEdit = () => {
        onEdit(record)
      }
      const handleDelete = () => {
        onDelete(record)
      }
      const handleStop = () => {
        onStop(record)
      }
      const isStopped = record.status === 'stopped'
      return (
        <span style={{ display: 'flex', justifyContent: 'flex-start', gap: '8px' }}>
          <Typography.Link onClick={handleEdit}>
            <ButtonActionWrapper title="Изменить">
              <EditOutlined />
            </ButtonActionWrapper>
          </Typography.Link>
          {!isStopped && (
            <Typography.Link onClick={handleStop}>
              <ButtonActionWrapper title="Остановить" style={{ color: 'orange' }}>
                <StopOutlined />
              </ButtonActionWrapper>
            </Typography.Link>
          )}
          <Typography.Link onClick={handleDelete}>
            <ButtonActionWrapper title="Удалить" style={{ color: 'red' }}>
              <DeleteOutlined />
            </ButtonActionWrapper>
          </Typography.Link>
        </span>
      )
    },
  },
]

export const getColumns = (
  sorter: Sorter,
  onStop: (record: DataType) => void,
  onEdit: (record: DataType) => void,
  onDelete: (record: DataType) => void,
) => {
  return createColumns(onStop, onEdit, onDelete).map(item => {
    if (item.key === sorter.sort_field) {
      item.sortOrder = sorter.sort_order
    } else {
      delete item.sortOrder
    }
    return item
  })
}
